// eslint-disable-next-line max-len
export const ytRegExp = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=|shorts\/))((\w|-){11})(?:\S+)?$/;

function getVideoId(url) {
  const match = url.match(ytRegExp);

  console.log('match', match);

  return match ? match[1] : url;
}
export function getEmbedUrlYoutube(rawUrl) {
  const id = getVideoId(rawUrl);

  return `${location.protocol}//www.youtube.com/embed/${id}`;
}
